import { render, staticRenderFns } from "./qualification-link.vue?vue&type=template&id=dab6884a&scoped=true&"
import script from "./qualification-link.vue?vue&type=script&lang=js&"
export * from "./qualification-link.vue?vue&type=script&lang=js&"
import style0 from "./qualification-link.vue?vue&type=style&index=0&id=dab6884a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab6884a",
  null
  
)

export default component.exports